/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-03-19 16:09:30 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-03-19 16:11:57
 */

export function bindMethods(target, members = undefined) {

    for (const name of members || Object.getOwnPropertyNames(target)) {
        if (typeof target[name] === "function") {
            target[name] = target[name].bind(target);
        }
    }

}


// WEBPACK FOOTER //
// ./app/helpers/bindMethods.js